export enum TabTerms {
    'no_term' = i18next.t('enum.TabTerms.no_term'),
    'completed' = i18next.t('enum.TabTerms.completed'),
}
